/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_Key_PlaceholderInputs */

const en_admin_settings_custom_key_placeholder = /** @type {(inputs: Admin_Settings_Custom_Key_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`config_key`)
};

const zh_admin_settings_custom_key_placeholder = /** @type {(inputs: Admin_Settings_Custom_Key_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`config_key`)
};

/**
* | output |
* | --- |
* | "config_key" |
*
* @param {Admin_Settings_Custom_Key_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_key_placeholder = /** @type {((inputs?: Admin_Settings_Custom_Key_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_Key_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_key_placeholder(inputs)
	return zh_admin_settings_custom_key_placeholder(inputs)
});
export { admin_settings_custom_key_placeholder as "admin.settings.custom.key_placeholder" }